<div role="document">
  <header class="modal-header pb-0 px-4 mt-2">
    <h3 class="modal-title">Documentos necessários</h3>
    <a class="header__btn__close" (click)="activeModal.close(true)">
      <span aria-hidden="true">X</span>
    </a>
  </header>
  <main class="modal-body">
    <div class="col-12 mb-1">
      <b>
        Atenção! Antes de prosseguir com o preenchimento do formulário tenha em mãos os seguintes documentos.
      </b>
    </div>
    <section>
      <ul>
        <li>Certidão de nascimento em caso de filhos recém nascidos.</li>
        <li>RG, CPF ou CNH do Filho ou Enteado;</li>
      </ul>
    </section>
    <!-- <form class="col-12" [formGroup]="formData" [@fadeInOut]>
      <section class="col-12 mt-1" [@fadeInOut]>
        <label class="label-form">O menor possui menos de 18 (dezoito) anos de idade?</label>
        <div>
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="menorDezoito1" class="custom-control-input" formControlName="menorDezoito"
              name="menorDezoito" value="true" (click)="blur($event)">
            <label class="custom-control-label" for="menorDezoito1">Sim</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="menorDezoito2" class="custom-control-input" formControlName="menorDezoito"
              name="menorDezoito" value="false" (click)="blur($event)">
            <label class="custom-control-label" for="menorDezoito2">Não</label>
          </div>
        </div>
      </section>
      <section *ngIf="formData.controls.menorDezoito.value == 'true' ">
        <section class="col-12 mt-1" *ngIf="formData.controls.menorDezoito.value == 'true'" [@fadeInOut]>
          <label class="label-form">Você é o(a) responsável Legal desse?</label>
          <div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="responsavelJudicial1" class="custom-control-input"
                formControlName="responsavelJudicial" name="responsavelJudicial" value="true" (click)="blur($event)">
              <label class="custom-control-label" for="responsavelJudicial1">Sim</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="responsavelJudicial2" class="custom-control-input"
                formControlName="responsavelJudicial" name="responsavelJudicial" value="false" (click)="blur($event)">
              <label class="custom-control-label" for="responsavelJudicial2">Não</label>
            </div>
          </div>
        </section>
        <section class="col-12 mt-1" *ngIf="formData.value.responsavelJudicial != null" [@fadeInOut]>
          <label class="label-form">O menor possui menos de 12 (doze) anos de idade?</label>
          <div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="menorDoze1" class="custom-control-input" formControlName="menorDoze"
                name="menorDoze" value="true" (click)="blur($event)">
              <label class="custom-control-label" for="menorDoze1">Sim</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="menorDoze2" class="custom-control-input" formControlName="menorDoze"
                name="menorDoze" value="false" (click)="blur($event)">
              <label class="custom-control-label" for="menorDoze2">Não</label>
            </div>
          </div>
        </section>


        < <section class="col-12 mt-1" *ngIf="formData.get('menorDoze').value == 'true'" [@fadeInOut]>
            <label class="label-form">Você possui o termo de consentimento assinado?</label>
            <div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="termoConsentimento1" class="custom-control-input" formControlName="termoConsentimento" name="termoConsentimento" value="true">
                <label class="custom-control-label" for="termoConsentimento1">Sim</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="termoConsentimento2" class="custom-control-input" formControlName="termoConsentimento" name="termoConsentimento" value="false">
                <label class="custom-control-label" for="termoConsentimento2">Não</label>
              </div>
            </div>
          </section> 


        <section class="col-12 content-aviso-footer mt-2" *ngIf="formData.controls.menorDoze.value == 'true'"
          [@fadeInOut]>
          <b>
            Atenção!
          </b>
          <p>
            Com o objetivo de aprimorar suas atividades e proporcionar um serviço de qualidade, a <b>FUNDAÇÃO COPEL</b>
            realiza o tratamento de dados dos participantes e beneficiários. No caso de menores de 12 (doze) anos, a
            <b>LGPD</b> estabelece o consentimento como uma das opções de hipótese legal para o tratamento de dados.
            Nesse sentido, é essencial que um dos pais ou o responsável legal do menor leia cuidadosamente o termo de
            consentimento e autorize o tratamento de dados.
          </p>
          <p>
            A recusa pode resultar no impedimento ou interrupção da prestação de serviços.
          </p>
           <p>
              Como os dados coletados são necessários para o cumprimento de obrigações contratuais e também de 
              ordem legal impostas à FUNDAÇÃO COPEL pela Lei Complementar 108/2001 e pelo Decreto 4.942/2003, 
              a ausência do consentimento específico exigido pela Lei Geral de Proteção de Dados impedirá a prestação 
              de serviços e outorga de benefícios à criança beneficiária, assim consideradas as menores de 
              12 (doze) anos de idade. 
            </p> 
          <p>
            Sendo assim, segue formulário para download e preenchimento do responsável legal do menor.
          </p>
          <button class="btn btn-outline-primary"
            (click)="downloadTermo()">
            Download Termo de Consentimento
          </button>
        </section>
      </section>
    </form> -->
  </main>
  <footer class="modal-footer" >
    <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" (click)="closeModal()"
      >
      Continuar
    </button>
  </footer>
  <div>